import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.css']
})
export class LoadingOverlayComponent {
  @Input() isLoading: boolean = false;
  @Input() message: string = 'Carregando dados...';
  @Input() spinnerDiameter: number = 40;
  @Input() overlayColor: string = 'rgba(255,255,255,0.8)';
  @Input() spinnerColor: string = '#FF9137';

  constructor(private translate: TranslateService) {
    // Initialize with translated default message if no message provided
    if (this.message === 'Carregando dados...') {
      this.message = this.translate.instant('loading.data');
    }
  }
}
